export default __webpack_public_path__ + "static/1884-318b89aeb6fe87faeebe70faa45124f6.gif";